<template>
	<div>
		<b-toast id="form-toast" variant="danger" solid name="b-toaster-top-center">
			<template #toast-title>
				<div class="d-flex flex-grow-1 align-items-baseline">
					<b-img blank blank-color="#ff5555" class="mr-2" width="12" height="12" />
					<strong class="mr-auto">Erro!</strong>
				</div>
			</template>

			Por favor, preencha todos os campos obrigatórios.
		</b-toast>

		<b-modal
			id="invalid-id-modal"
			ref="invalidIdModal"
			hide-footer
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-header-close
			size="md">
			<template #modal-header>
				<div class="d-flex justify-content-between align-items-start w-100">
					<h5 class="modal-title">Erro</h5>
				</div>
			</template>

			<div class="text-center">
				<p>URL inválida! Por favor, tente novamente ou entre em contato com seu gerente de conta.</p>
			</div>
		</b-modal>

		<success-component :show="step == 5">
			<strong>Obrigado, seu cadastro foi finalizado!</strong>
			<br />
			Por favor, aguarde que entraremos em contato.
		</success-component>

		<Loader v-show="!isMounted || loadingButton" />
		<header-component :title="$root.isMobile() ? $t('steps_mobile')[step] : $t('steps')[step]" />

		<div class="container" v-if="isValidId">
			<div class="row content">
				<div class="col-lg-5 col-12" :style="step == 5 ? 'background: #fff;' : ''">
					<steps-component
						:current-step="step"
						v-if="isMounted"
						:style="step == 5 ? 'opacity: 0.2; pointer-events: none;' : ''" />
				</div>

				<div
					class="col-lg-7 col-12 scroll"
					:class="{
						'd-flex justify-content-between flex-column': $root.isMobile() && step == steps.personal,
					}"
					:style="step == 5 ? 'display: none;' : ''">

					<div class="alert alert-danger text-center" v-if="showSalesforceGetError">
						Não foi possível recuperar as informações salvas. Por favor, tente novamente.
					</div>

					<div class="alert alert-danger text-center" v-if="showSalesforcePostError">
						<template v-if="salesforcePostErrorMessage.includes('Last name is required')">
							Por favor, insira ao menos um sobrenome.
						</template>

						<template v-else>
							Não foi possível enviar o formulário. Por favor, tente novamente.
						</template>
					</div>

					<div v-if="isMounted">
						<p class="required-fields">Preenchimento obrigatório*</p>

						<h2 v-if="!$root.isMobile()">
							{{ $t("steps")[step] }}
						</h2>

						<!-- FORMULÁRIO DE DADOS PESSOAIS -->
						<KeepAlive>
							<personal-form-component
								:formSession="true"
								:hidden-data="true"
								v-if="step === steps.personal"
								ref="formPersonal"
								:validation-trigger="validationTrigger"
								@setReadyToSubmit="setReadyToSubmit" />
						</KeepAlive>

						<!-- FORMULÁRIO DE DADOS DO ESTABELECIMENTO -->
						<KeepAlive>
							<establishment-form-component
								v-if="step === steps.establishment"
								ref="formEstablishment"
								:validation-trigger="validationTrigger"
								@setReadyToSubmit="setReadyToSubmit" />
						</KeepAlive>

						<!-- FORMULÁRIO DE SÓCIOS E CONTATOS -->
						<KeepAlive>
							<owners-and-contacts-form-component
								v-if="step === steps.contacts"
								ref="formContacts"
								:validation-trigger="validationTrigger"
								@setReadyToSubmit="setReadyToSubmit" />
						</KeepAlive>

						<!-- FORMULÁRIO DE INTEGRAÇÕES -->
						<KeepAlive>
							<integrations-form-component
								v-if="step === steps.integrations"
								ref="formIntegrations"
								:validation-trigger="validationTrigger"
								@setReadyToSubmit="setReadyToSubmit" />
						</KeepAlive>

						
						<!-- FORMULÁRIO DE DADOS BANCÁRIOS -->
						<KeepAlive>
							<bank-form-component
								v-if="step === steps.bank"
								ref="formBank"
								:validation-trigger="validationTrigger"
								@setReadyToSubmit="setReadyToSubmit" />
						</KeepAlive>
					</div>

					<div
						v-if="isMounted"
						class="d-flex align-items-center"
						:class="[
							$root.isMobile() ? 'flex-column' : 'flex-row',
							$store.state.form.establishment.exposed ? 'm-special' : '',
							step ? 'justify-content-between m-30' : 'justify-content-end',
						]">
						<a @click="previousStep" class="link" v-if="!$root.isMobile() && step">Voltar</a>

						<!-- BOTÃO -->
						<b-button
							v-if="step < 5"
							@click="nextStep"
							:disabled="loadingButton"
							:class="!loadingButton ? 'bg-primary text-white' : ''"
							size="lg">
							{{ buttonText }}
							<b-spinner style="width: 1rem; height: 1rem" v-if="loadingButton" variant="dark" />
						</b-button>

						<a @click="previousStep" class="link mt-3" v-if="$root.isMobile() && step">Voltar</a>
					</div>

					<div class="alert alert-danger text-center" v-if="showError">
						Não foi possível salvar as informações. Por favor, tente novamente.
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HeaderComponent from "@/components/Main/HeaderComponent";
import StepsComponent from "@/components/Main/StepsComponent";

import PersonalFormComponent from "@/components/Form/PersonalFormComponent";
import EstablishmentFormComponent from "@/components/Form/EstablishmentFormComponent";
import OwnersAndContactsFormComponent from "@/components/Form/OwnersAndContactsFormComponent";
import IntegrationsFormComponent from "@/components/Form/IntegrationsFormComponent";
import BankFormComponent from "@/components/Form/BankFormComponent";
import Loader from "@/components/Main/Loader";
import SuccessComponent from "@/components/Form/SuccessComponent";

export default {
	name: "MainPage",
	components: {
		HeaderComponent,
		PersonalFormComponent,
		StepsComponent,
		EstablishmentFormComponent,
		OwnersAndContactsFormComponent,
		IntegrationsFormComponent,
		BankFormComponent,
		SuccessComponent,
		Loader,
	},
	async mounted() {
		
		let store = this.$store;
		store.state.form.step = 0;

		if (this.$route.query.id) {
			sessionStorage.setItem("kyc_uuid", this.$route.query.id);
		}

		if (sessionStorage.getItem("kyc_uuid")) {
			await Promise.all([
				store.dispatch("getPersonalData"),
				store.dispatch("getEstablishmentData"),
				store.dispatch("getContactsData"),
				store.dispatch("getIntegrationData"),
				store.dispatch("getUploadedFiles"),
				store.dispatch("getBankAccountData"),
			]).catch((error) => {
				if (error.message?.includes("missing KYC record ID")) {
					this.isValidId = false;
					this.$refs.invalidIdModal.show();
				} else {
					this.$store.commit("setShowSalesforceGetError", true);
					this.$store.commit("setLoadingButton", false);
				}
			});
		}

		this.isMounted = true;
	},
	data() {
		return {
			isMounted: false,
			isValidId: true,
			steps: {
				personal: 0,
				establishment: 1,
				contacts: 2,
				integrations: 3,
				bank: 4,
			},
			readyToSubmit: false,
			showError: false,
			// prop para fazer os formulários filhos rodarem a rotina de validação, através do watch()
			validationTrigger: false,
		};
	},
	computed: {
		loadingButton: {
			get() {
				return this.$store.state.form.loadingButton;
			},
			set(value) {
				this.$store.commit("setLoadingButton", value);
			},
		},
		enableButton() {
			return this.readyToSubmit;
		},
		step: {
			get() {
				return this.$store.state.form.step;
			},
			set(value) {
				this.$store.dispatch("updateStep", value);
				this.$store.commit("setStep", value);
				this.readyToSubmit = false;

				this.$nextTick(() => {
					let selector = this.$root.isMobile() ? window : document.querySelector(".scroll");

					selector.scrollTo({
						top: 0,
						left: 0,
						behavior: "smooth",
					});
				});
			},
		},
		buttonText() {
			if (this.$t("steps").length - 1 == this.step) {
				return "Finalizar";
			}

			return this.loadingButton ? "" : "Próximo Passo";
		},
		showSalesforceGetError() {
			return this.$store.state.form.showSalesforceGetError;
		},
		showSalesforcePostError() {
			return this.$store.state.form.showSalesforcePostError;
		},
		salesforcePostErrorMessage() {
			return this.$store.state.form.salesforcePostErrorMessage;
		}
	},
	methods: {
		setReadyToSubmit(isReady) {
			this.readyToSubmit = isReady;
		},
		async nextStep() {
			this.validationTrigger = !this.validationTrigger;

			await this.$nextTick(async () => {
				await this.$forceUpdate();

				if (!this.readyToSubmit) {
					this.$utils.triggerFields();
					this.$bvToast.show("form-toast");

					return;
				}

				this.showError = false;
				this.loadingButton = true;

				let success = await this.$store.dispatch("submitForm", this.step);
				this.loadingButton = false;

				if (success) {
					this.step++;
					return true;
				}

				this.showError = true;
			});
		},
		async previousStep() {
			if (!this.step) {
				return;
			}

			this.step--;

			await this.$nextTick(() => {
				this.validationTrigger = !this.validationTrigger;
			});
		},
		makeToast(variant = null, type) {
			let message = "Por favor, preencha todos os campos obrigatórios.";

			if (type === "cpfCnpj") {
				message = "Não é possível enviar CPF ou CNPJ sem máscara.";
			}

			this.$bvToast.toast(message, {
				title: `Erro`,
				variant,
				solid: true,
				toaster: "b-toaster-top-center",
			});
		},
	},
	watch: {
		step(value) {
			if (value !== 5) {
				return;
			}

			this.$store.dispatch("updateStep", this.step);
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/scss/colors";
@import "@/assets/scss/styles";
@import "@/assets/scss/form";
</style>

<style lang="scss" scoped>
@import "@/assets/scss/styles";

.container {
	max-width: 100%;
}

.row > div {
	margin: 0;
	padding: 18px 0;
	padding-top: 50px;
	height: calc(100vh - 69px);
}

.row .col-lg-5 {
	padding-left: $grid-padding;
	background-color: #f6f6f6;
}

.row .col-lg-7 {
	padding-right: $grid-padding;
	padding-left: 70px;
	max-height: calc(100vh - 69px);
	overflow-y: scroll;
}

.required-fields {
	color: #686361;
	font-family: "Nunito Sans";
	font-size: 14px;
	letter-spacing: 0;
	line-height: 19px;
}

.link {
	font-family: "Nunito Sans";
	color: #007bff;
	font-size: 13px;
	text-transform: uppercase;
	cursor: pointer;
	letter-spacing: 0;
	line-height: 19px;
}

.link:hover {
	text-decoration: none;
}

.m-30 {
	margin: 30px 0;
}

.m-special {
	margin-top: 70px !important;
}

.alert {
	font-size: 13px;
}

@media only screen and (max-width: 1600px) {
	$grid-padding: 10%;

	.row .col-lg-5 {
		padding-left: $grid-padding;
	}

	.row .col-lg-7 {
		padding-right: $grid-padding;
	}
}

@media only screen and (max-width: 1200px) {
	$grid-padding: 2%;

	.row .col-lg-5 {
		padding-left: $grid-padding;
	}

	.row .col-lg-7 {
		padding-right: $grid-padding;
	}
}

@media only screen and (max-width: 1024px) {
	.content > .col-lg-5 {
		height: auto;
		background-color: #fff;
		padding: 0px;
		padding-top: 5px;
	}

	.content > .col-lg-7 {
		padding: 20px !important;
		padding-left: 70px;
		overflow-y: initial !important;
	}

	.row {
		margin: 0 0px;
	}

	.row > div {
		height: calc(100vh - 85px);
	}

	.required-fields {
		font-size: 12px;
		margin-bottom: 20px;
	}

	.button-fixed {
		position: relative;
		left: 0;
		bottom: 20px;
		padding: 20px 95px;
		margin-top: 30px;
		margin-bottom: 0px;
	}

	.m-30 {
		margin: 30px 0 20px 0;
	}

	.m-special {
		margin-top: 80px !important;
	}
}
</style>
